import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const streamBannerContentContainer = style([
  {
    display: 'flex',
    flexDirection: 'column',
  },
]);

export const streamBannerBodyContainer = style([
  {
    display: 'flex',
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
      gap: space.s8,
    },
    tablet: {
      flexDirection: 'row',
      gap: space.s24,
    },
  }),
]);

globalStyle(`${streamBannerBodyContainer} > div`, {
  flex: '1 1 0',
});

export const streamBannerBody = style([
  {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxWidth: 630,
  },
]);

export const streamName = style([
  {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  responsiveStyle({
    mobile: {
      margin: `${space.s5}px 0`,
      ...typography.titleLg,
    },
    tablet: {
      margin: `${space.s2}px 0`,
      ...typography.headlineLg,
    },
  }),
]);
